import { action } from 'satcheljs';
import type { ClientItemId } from 'owa-client-ids';

/**
 * Shows the context menu and sets it's calendarItem
 */
let showItemContextMenu = action(
    'showItemContextMenu',
    (itemId: ClientItemId, containerId: string, clickEvent: React.MouseEvent<HTMLDivElement>) => ({
        itemId: itemId,
        containerId: containerId,
        clickEvent: clickEvent,
    })
);

export default showItemContextMenu;
